<template>

    <div class="faq" @click.prevent="show = !show" :class="{ expanded: show }">
        <p class="question">{{ q }}</p>
        <transition name="fade">
            <div v-if="show" class="answer">
                <slot></slot>
            </div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    .faq {
        border-bottom: 1px solid $color-rule;
        cursor: pointer;
        padding: 20px 0;
        text-align: left;
        &:hover, &.expanded {
            .question {
                color: $color-primary;
            }
        }
        .question {
            color: $color-text;
            margin: 0;
            text-align: left;
        }
        .answer {
            @include font-medium(14px);
            line-height: 1.8em;
            overflow: hidden;
            padding-top: 10px;
        }
    }

</style>

<script>

export default {

    props: {
        q: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            show: false,
        }
    },

}

</script>